import {
  Avatar,
  Group,
  Menu,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  UnstyledButton
} from '@mantine/core'
import { useHover } from '@mantine/hooks'
import {
  IconCreditCard,
  IconLogout,
  IconUser,
  IconUsersGroup
} from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { RouterPath } from '@/router/paths'
import { useSession } from '@/session/SessionContext'
import { useLogout } from '@/session/useLogout'

type UserAvatarProps = {
  fullName: string
}

const UserAvatar = ({ fullName }: UserAvatarProps) => {
  const { hovered, ref } = useHover()

  return (
    <Avatar
      ref={ref}
      variant="filled"
      name={fullName}
      color={hovered ? 'blue.7' : 'blue.9'}
      styles={(theme) => ({
        root: {
          outline: hovered
            ? `2px solid ${theme.colors['brand-primary'][1]}`
            : `2px solid ${theme.colors['brand-primary'][2]}`
        }
      })}
    />
  )
}

export const UserMenu = () => {
  const { user } = useSession()
  const { logout } = useLogout()

  const fullName = user ? `${user.first_name} ${user.last_name}` : ''

  const handleLogout = () => {
    void logout()
  }

  return (
    <Menu shadow="md" width={320} withArrow>
      <Menu.Target>
        <UnstyledButton>
          <UserAvatar fullName={fullName} />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>
          <FormattedMessage id="account" />
        </Menu.Label>

        <Menu.Divider />

        <Paper p="xs">
          <Group wrap="nowrap" align="start" gap="xs">
            <ThemeIcon size="sm" radius="xl" color="brand-primary.4">
              <IconUser style={{ width: '80%', height: '80%' }} />
            </ThemeIcon>

            <Stack gap={4}>
              <Text size="xs" fw={600}>
                {user?.first_name} {user?.last_name}
              </Text>

              <Text
                w={200}
                size="xs"
                styles={{
                  root: {
                    overflowWrap: 'break-word'
                  }
                }}
              >
                {user?.email}
              </Text>
            </Stack>
          </Group>
        </Paper>

        <Menu.Divider />

        <Menu.Item
          component={Link}
          to={RouterPath.workspace}
          leftSection={<IconUsersGroup size={14} />}
        >
          <FormattedMessage id="header.menu.workspace" />
        </Menu.Item>

        <Menu.Item
          component={Link}
          to={RouterPath.subscription}
          leftSection={<IconCreditCard size={14} />}
        >
          <FormattedMessage id="header.menu.license" />
        </Menu.Item>

        <Menu.Item
          leftSection={<IconLogout size={14} />}
          onClick={handleLogout}
        >
          <FormattedMessage id="logout" />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
